import { createSlice } from '@reduxjs/toolkit';

const initialState = { total: 0 };

export const chatUnreadSlice = createSlice({
  name: 'chatUnread',
  initialState,
  reducers: {
    setTotalUnread: (state, action) => {
      state.total = action.payload;
    },
  },
});

export const { setTotalUnread } = chatUnreadSlice.actions;
export default chatUnreadSlice.reducer;
